/**
 * extra controller used for managing single extras
 */
angular.module('bookingApp').controller('extraController', function ($scope, $routeParams, $http, sessionFactory) {
    /** @namespace $routeParams.categoryId */
    $scope.selectedExtraCategoryIndex = $routeParams.categoryId;
    $scope.selectedExtraIndex = $routeParams.extraId;
    $scope.selectedExtra = $scope.extras.getSpecificExtra($scope.selectedExtraCategoryIndex, $scope.selectedExtraIndex);
    $scope.editingExtra = false;
    // setup footer control
    $scope.setupStandardCartFooter();
    $scope.footer.nextFunc = nextFunc;
    if($scope.property.isItemOnly){
        $scope.setupItemOnlyFooter();
    }
    $scope.editExtraFunc = editExtraFunc;
    $scope.removeExtraFunc = removeExtraFunc;
    // calculate the selected amount of pax types
    if($scope.property.isItemOnly){
        $scope.selectedAdults = 0;
        $scope.selectedChildren = 0;
        $scope.selectedInfants = 0;
    } else {
        $scope.selectedAdults = $scope.cart.rooms[$scope.cart.rooms.length - 1].paxConfig.adults;
        $scope.selectedChildren = $scope.cart.rooms[$scope.cart.rooms.length - 1].paxConfig.children;
        $scope.selectedInfants = $scope.cart.rooms[$scope.cart.rooms.length - 1].paxConfig.infants;
    }
    $scope.selectedQuantity = 1;
    // calculate the maximum values
    $scope.getMax = getMax;
    // function used to get the photos for the extra
    $scope.getPhotos = getPhotos;
    // setup the pricing object to be passed into the selector directive - acts as a wrapper for the extra modules pricing function
    $scope.pricing = pricing;
    $scope.addToCart = addToCart;
    $scope.getDescription = getDescription;
    $scope.populatePurchaser = populatePurchaser;
    $scope.prePopulateLeadGuest = prePopulateLeadGuest;

    function populatePurchaser(firstName, lastName) {
        if(!sessionFactory.booking.leadGuest.firstName){
            sessionFactory.booking.leadGuest.firstName = firstName;
            sessionFactory.booking.leadGuest.lastName = lastName;
        }
    }

    function prePopulateLeadGuest(title, firstName, lastName, email, phone, mobile, postAddress, suburb, city, postCode, country){
        sessionFactory.booking.leadGuest.title = title;
        sessionFactory.booking.leadGuest.firstName = firstName;
        sessionFactory.booking.leadGuest.lastName = lastName;
        sessionFactory.booking.leadGuest.email = email;
        sessionFactory.booking.leadGuest.phone = phone;
        sessionFactory.booking.leadGuest.mobile = mobile;
        sessionFactory.booking.leadGuest.address = postAddress;
        sessionFactory.booking.leadGuest.suburb = suburb;
        sessionFactory.booking.leadGuest.city = city;
        sessionFactory.booking.leadGuest.postcode = postCode;
        sessionFactory.booking.leadGuest.addressCountry = country;
    }

    function nextFunc() {
        $scope.goToCart();
    }

    function editExtraFunc() {}

    function removeExtraFunc() {}

    function getMax() {
        // get the max qunaityt and the max from the rate then take the lowest value for these.
        var specificExtra = $scope.extras.getSpecificExtra($scope.selectedExtraCategoryIndex, $scope.selectedExtraIndex);
        var maxPerBooking = specificExtra.maxPerBooking;
        // need to check if the extra is already in the cart, if so check if the max quantity has been hit otherwise st this as the max quantity
        var maxQuantity = null;
        for (rate in specificExtra.rates) {
            if (specificExtra.rates.hasOwnProperty(rate)) {
                var tmpMaxQuantity = specificExtra.rates[rate].maxQuantity;
                if (!maxQuantity) {
                    maxQuantity = tmpMaxQuantity;
                } else {
                    if (maxQuantity > tmpMaxQuantity) {
                        maxQuantity = tmpMaxQuantity;
                    }
                }
            }
        }
        if(!maxQuantity && !maxPerBooking){
            maxQuantity = 100;
        }
        if (maxQuantity && maxPerBooking) {
            if (maxQuantity > maxPerBooking) {
                return maxQuantity;
            } else {
                return maxPerBooking;
            }
        } else {
            if(maxPerBooking){
                return maxPerBooking;
            }
            if(maxQuantity){
                return maxQuantity;
            }
            return '';
        }
    }

    function getPhotos() {
        return $scope.extras.getPhotos($scope.selectedExtraCategoryIndex, $scope.selectedExtraIndex);
    }

    // setup the pricing object to be passed into the selector directive - acts as a wrapper for the extra modules pricing function
    $scope.pricing = function (quantity, startDate, endDate, adults, children, infants, isItemOnly) {
        // update to take into consideration adults / children / infants
        var priceOb = $scope.extras.checkPricing(parseInt($scope.selectedExtraCategoryIndex), parseInt($scope.selectedExtraIndex), moment(startDate).toDate(), moment(endDate).toDate(), quantity, $scope.extras.extras, $scope.extras.extrasPrices, ExtraPricing.buildPaxConfiguration(adults, children, infants), isItemOnly);
        return priceOb;
    }

    function addToCart(quantity, startDate, endDate, adults, children, infants, bookingLevel, paxDetails, existingResId, startTime, endTime, reloadExtra, customFields) {
        var selectedExtra = $scope.extras.getSpecificExtra($scope.selectedExtraCategoryIndex, $scope.selectedExtraIndex);
        var priceOb = $scope.extras.checkPricing(parseInt($scope.selectedExtraCategoryIndex), parseInt($scope.selectedExtraIndex), moment(startDate).toDate(), moment(endDate).toDate(), quantity, $scope.extras.extras, $scope.extras.extrasPrices, ExtraPricing.buildPaxConfiguration(adults, children, infants), isItemOnly);
        var extraDates = [startDate, endDate];
        var paxConfig = ExtraPricing.buildPaxConfiguration(adults, children, infants);
        paxDetails.formattedDOB = moment(paxDetails.dob).format('YYYY-MM-DD');
        var extraCartOb = {
            extra: selectedExtra,
            extraStart: startDate,
            extraEnd: endDate,
            paxConfig: paxConfig,
            quantity: quantity,
            pricing: priceOb,
            customFields: customFields,
            paxDetails: paxDetails,
            startTime: startTime,
            endTime: endTime,
            existingResId: existingResId
        };

        if (bookingLevel !== 'booking') {
            if (typeof $scope.cart.rooms[parseInt(bookingLevel)].selectedExtras === 'undefined') {
                $scope.cart.rooms[parseInt(bookingLevel)].selectedExtras = [];
            }
        }

        // check the chargable to level and add the extra
        switch (selectedExtra.chargeableTo) {
            case 2:
                // add the extra to booking
                cart.bookingExtras.selected.push(extraCartOb);
                break;
            case 1: // room level only
                // add the extra to the rooms extras array
                $scope.cart.rooms[parseInt(bookingLevel)].selectedExtras.push(extraCartOb);
                break;
            case 3: // room and booking level
            default:
                if (bookingLevel === 'booking') {
                    cart.bookingExtras.selected.push(extraCartOb);
                } else {
                    $scope.cart.rooms[parseInt(bookingLevel)].selectedExtras.push(extraCartOb);
                }
                break;
        }

        //$scope.cart.extras.push(extraCartOb);
        $scope.safeApply();

        // redirect the user back to the extras screen
        if($scope.property.isItemOnly && !reloadExtra){
            $scope.goToPage('cart');
        }else{
            $scope.goToPage('extras');
        }
    };

    function getDescription() {
        return $scope.extras.getSpecificExtra($scope.selectedExtraCategoryIndex, $scope.selectedExtraIndex).description;
    };

    $scope.showLoader = function(){
        $scope.session.isLoading = true;
    }
    $scope.hideLoader = function(){
        $scope.session.isLoading = false;
    }
});